import axios from 'axios';
import { useEffect, useState } from 'react';
import {app} from '../config'
const getCityById = (id) => {
    let reqid=id
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const getCity = async (id) => {
          try {
            const res = await axios.get(`${app.URL}/city/view/${id}`);
            console.log(res);
            setResponse(res.data);
            setLoading(false);
          } catch (err) {
            setError(err);
            setLoading(false);
          }
        };
        getCity(reqid);
      }, []);
    
      return { loading, response, error };
    };
export default getCityById